import React from 'react';
import { Sparkles } from 'lucide-react';

interface InstantDrawFieldProps {
  instantDraw: boolean;
  onChange: (value: boolean) => void;
}

const InstantDrawField: React.FC<InstantDrawFieldProps> = ({ instantDraw, onChange }) => {
  return (
    <div className="space-y-2">
      <label className="block text-xs font-bold uppercase tracking-wider text-tinta">
        <Sparkles className="inline w-4 h-4 mr-1 text-bordo" />
        Tipo de Sorteio
      </label>

      {/* Toggle Switch Style */}
      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={() => onChange(true)}
          className={`px-3 py-2.5 rounded-lg text-sm font-bold transition-colors border ${
            instantDraw
              ? 'bg-bordo text-creme border-bordo hover:bg-bordo-dark'
              : 'bg-white text-tinta-soft border-tinta/15 hover:bg-creme-light hover:text-tinta'
          }`}
        >
          Instantâneo
        </button>
        <button
          type="button"
          onClick={() => onChange(false)}
          className={`px-3 py-2.5 rounded-lg text-sm font-bold transition-colors border ${
            !instantDraw
              ? 'bg-bordo text-creme border-bordo hover:bg-bordo-dark'
              : 'bg-white text-tinta-soft border-tinta/15 hover:bg-creme-light hover:text-tinta'
          }`}
        >
          Agendado
        </button>
      </div>

      <p className="text-xs text-tinta-soft italic">
        {instantDraw
          ? 'Prêmio revelado ao girar a roda'
          : 'Sorteio em data específica'
        }
      </p>
    </div>
  );
};

export default InstantDrawField;
